// source: icws_proto/icws_api_gateway/processing/start_processing.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var icws_proto_icws_api_gateway_processing_base_pb = require('../../../icws_proto/icws_api_gateway/processing/base_pb.js');
goog.object.extend(proto, icws_proto_icws_api_gateway_processing_base_pb);
goog.exportSymbol('proto.InkCapture.StartProcessingRequest', null, global);
goog.exportSymbol('proto.InkCapture.StartProcessingRequest.SubjectCase', null, global);
goog.exportSymbol('proto.InkCapture.StartProcessingResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InkCapture.StartProcessingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.InkCapture.StartProcessingRequest.oneofGroups_);
};
goog.inherits(proto.InkCapture.StartProcessingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InkCapture.StartProcessingRequest.displayName = 'proto.InkCapture.StartProcessingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.InkCapture.StartProcessingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.InkCapture.StartProcessingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.InkCapture.StartProcessingResponse.displayName = 'proto.InkCapture.StartProcessingResponse';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.InkCapture.StartProcessingRequest.oneofGroups_ = [[3,4]];

/**
 * @enum {number}
 */
proto.InkCapture.StartProcessingRequest.SubjectCase = {
  SUBJECT_NOT_SET: 0,
  DOCUMENT_ID: 3,
  FOLDER_ID: 4
};

/**
 * @return {proto.InkCapture.StartProcessingRequest.SubjectCase}
 */
proto.InkCapture.StartProcessingRequest.prototype.getSubjectCase = function() {
  return /** @type {proto.InkCapture.StartProcessingRequest.SubjectCase} */(jspb.Message.computeOneofCase(this, proto.InkCapture.StartProcessingRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InkCapture.StartProcessingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.InkCapture.StartProcessingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InkCapture.StartProcessingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.StartProcessingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    params: (f = msg.getParams()) && icws_proto_icws_api_gateway_processing_base_pb.ProcessingParams.toObject(includeInstance, f),
    documentId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    folderId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InkCapture.StartProcessingRequest}
 */
proto.InkCapture.StartProcessingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InkCapture.StartProcessingRequest;
  return proto.InkCapture.StartProcessingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InkCapture.StartProcessingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InkCapture.StartProcessingRequest}
 */
proto.InkCapture.StartProcessingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = new icws_proto_icws_api_gateway_processing_base_pb.ProcessingParams;
      reader.readMessage(value,icws_proto_icws_api_gateway_processing_base_pb.ProcessingParams.deserializeBinaryFromReader);
      msg.setParams(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFolderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InkCapture.StartProcessingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InkCapture.StartProcessingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InkCapture.StartProcessingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.StartProcessingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParams();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      icws_proto_icws_api_gateway_processing_base_pb.ProcessingParams.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.InkCapture.StartProcessingRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.StartProcessingRequest} returns this
 */
proto.InkCapture.StartProcessingRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ProcessingParams params = 2;
 * @return {?proto.InkCapture.ProcessingParams}
 */
proto.InkCapture.StartProcessingRequest.prototype.getParams = function() {
  return /** @type{?proto.InkCapture.ProcessingParams} */ (
    jspb.Message.getWrapperField(this, icws_proto_icws_api_gateway_processing_base_pb.ProcessingParams, 2));
};


/**
 * @param {?proto.InkCapture.ProcessingParams|undefined} value
 * @return {!proto.InkCapture.StartProcessingRequest} returns this
*/
proto.InkCapture.StartProcessingRequest.prototype.setParams = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.InkCapture.StartProcessingRequest} returns this
 */
proto.InkCapture.StartProcessingRequest.prototype.clearParams = function() {
  return this.setParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.StartProcessingRequest.prototype.hasParams = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string document_id = 3;
 * @return {string}
 */
proto.InkCapture.StartProcessingRequest.prototype.getDocumentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.StartProcessingRequest} returns this
 */
proto.InkCapture.StartProcessingRequest.prototype.setDocumentId = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.InkCapture.StartProcessingRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.StartProcessingRequest} returns this
 */
proto.InkCapture.StartProcessingRequest.prototype.clearDocumentId = function() {
  return jspb.Message.setOneofField(this, 3, proto.InkCapture.StartProcessingRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.StartProcessingRequest.prototype.hasDocumentId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string folder_id = 4;
 * @return {string}
 */
proto.InkCapture.StartProcessingRequest.prototype.getFolderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.StartProcessingRequest} returns this
 */
proto.InkCapture.StartProcessingRequest.prototype.setFolderId = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.InkCapture.StartProcessingRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.InkCapture.StartProcessingRequest} returns this
 */
proto.InkCapture.StartProcessingRequest.prototype.clearFolderId = function() {
  return jspb.Message.setOneofField(this, 4, proto.InkCapture.StartProcessingRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.InkCapture.StartProcessingRequest.prototype.hasFolderId = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.InkCapture.StartProcessingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.InkCapture.StartProcessingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.InkCapture.StartProcessingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.StartProcessingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    documentsTasksMap: (f = msg.getDocumentsTasksMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.InkCapture.StartProcessingResponse}
 */
proto.InkCapture.StartProcessingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.InkCapture.StartProcessingResponse;
  return proto.InkCapture.StartProcessingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.InkCapture.StartProcessingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.InkCapture.StartProcessingResponse}
 */
proto.InkCapture.StartProcessingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    case 2:
      var value = msg.getDocumentsTasksMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.InkCapture.StartProcessingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.InkCapture.StartProcessingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.InkCapture.StartProcessingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.InkCapture.StartProcessingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDocumentsTasksMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string request_id = 1;
 * @return {string}
 */
proto.InkCapture.StartProcessingResponse.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.InkCapture.StartProcessingResponse} returns this
 */
proto.InkCapture.StartProcessingResponse.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * map<string, string> documents_tasks = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.InkCapture.StartProcessingResponse.prototype.getDocumentsTasksMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.InkCapture.StartProcessingResponse} returns this
 */
proto.InkCapture.StartProcessingResponse.prototype.clearDocumentsTasksMap = function() {
  this.getDocumentsTasksMap().clear();
  return this;};


goog.object.extend(exports, proto.InkCapture);
